import React, { useState, useContext, useEffect } from "react";
import FInputt from "../../components/FInputt/FInputt";
import { useGroup } from "../../hooks/useGroups";
import { useLocation, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useContacts } from "../../hooks/useContacts";
import { useFormat } from "../../hooks/useFormat";
import { AuthContext } from "../../context/AuthContext";
import FContainer from "../../components/FContainer/FContainer";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import * as Yup from "yup";
import Compress from "react-image-file-resizer";
import Swal from "sweetalert2";

const EditGroupScreen = ({ param }) => {
  const route = useNavigate();
  const { state } = useLocation();
  const [image, setImage] = useState(
    state?.picture
  );
  const [srcFileZoneSideBar, setSrcFileZoneSideBar] = useState();
  const { getBase64 } = useFormat();
  const { setAlert } = useContext(AuthContext);

  const { updateGroup } = useGroup();

  useEffect(() => {
    console.log(state);
  }, []);

  const validate = Yup.object({
    name: Yup.string().required("Ingresa tu nombre"),
    description: Yup.string().required("Ingresa una descripción al grupo"),
  });

  const editGroupFormik = useFormik({
    initialValues: {
      name: state?.name,
      description: state?.description,
      picture: state?.picture,
      members: "",
    },
    onSubmit: async (values) => {
      const { name, description, picture } = values;
      nextScreen(state.id, { name, description, picture });
    },
    validationSchema: validate,
  });

  const nextScreen = async (groupId, data) => {
    if ((await updateGroup(groupId, data)) == true) {
      const next = () => {
        route("/GroupScreen");
      };
      Swal.fire({
        showCloseButton: true,
        title: 'Éxito',
        text: "Se ha actualizado tu grupo.",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        // iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      }).then((result) => {
        if (result.isConfirmed) {
          next();
        } else{
          next();
        }
      })
    } else {
      Swal.fire({
        showCloseButton: true,
        title: 'Advertencia',
        text: "No se pudo actualizar tu grupo",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#fd6e0d',
        iconColor: "#fd6e0d",
        confirmButtonText: 'Entendido'
      })
    }
  };

  const onFileResize = e => {
    const file = e.target.files[0];
  
    Compress.imageFileResizer(
        file, // the file from input
        480, // width
        480, // height
        "JPEG", // compress format WEBP, JPEG, PNG
        70, // quality
        0, // rotation
        (uri) => {
          setImage(uri);
          editGroupFormik.setFieldValue('picture', uri)
          setSrcFileZoneSideBar(uri);
        },
        "base64" // blob or base64 default base64
      );
    };


  return (
    <FContainer>
      <div className="w-full border-0 grid place-items-center cursor-pointer">
        <label className="cursor-pointer rounded-lg">
          <img
            src={!srcFileZoneSideBar ? image : srcFileZoneSideBar}
            className="w-[150px] h-[150px] xxs:w-[200px] xxs:h-[200px] flex-1 pb-2 "
          />
          <input
                type="file"
                id="file"
                className="hidden"
                onChange={onFileResize}
                accept="image/png, image/gif, image/jpeg"
          />
        </label>
      </div>
      <FInputText
        title="Nombre"
        placeholder="Nombre"
        value={state?.name}
        onChange={(value) => {
          editGroupFormik.setFieldValue("name", value);
        }}
        errorMessage={editGroupFormik.errors.name}
      />
      <FInputText
        title="Description"
        placeholder="Description"
        value={state?.description}
        onChange={(value) => {
          editGroupFormik.setFieldValue("description", value);
        }}
        errorMessage={editGroupFormik.errors.description}
      />
      <Fbutton
        value="Actualizar"
        disabled={!editGroupFormik.isValid}
        onClick={editGroupFormik.handleSubmit}
      />
    </FContainer>
    // <div className="md:pl-[480px] md:pr-[480px]">

    //   <form onSubmit={editGroupFormik.handleSubmit}>
    //     <div className="col-span-4 sm:col-span-2  border-0 row-span-3 flex items-center place-content-center">
    //                 <div>
    //                     <label className="cursor-pointer rounded-lg">
    //                       <img
    //                         className="inline-block h-48 w-48"
    //                         src={
    //                           !srcFileZoneSideBar
    //                             ? image
    //                             : srcFileZoneSideBar
    //                         }
    //                       />
    //                       <input

    //                         type="file"
    //                         className="hidden"
    //                         onChange={async (e) => {
    //                           const result = await getBase64(e.target.files[0]);
    //                             setImage(result);
    //                             editGroupFormik.setFieldValue('picture', result)
    //                           setSrcFileZoneSideBar(result);
    //                         }}
    //                       />
    //                     </label>
    //                   </div>
    //     </div>

    //     <FInputt
    //             value={state?.name}
    //             type="text"
    //             name="name"
    //             title="Nombre"
    //             placeholder="Nombre del grupo"
    //             formik={editGroupFormik}
    //     />

    //     <FInputt
    //             value={state?.description}
    //             type="text"
    //             name="description"
    //             title="Descripción"
    //             placeholder="Mi familia, Hermanos García"
    //             formik={editGroupFormik}
    //     />

    //     <FInputt type="submit" title={"Editar grupo"} formik={editGroupFormik} />
    //   </form>

    // </div>
  );
};

export default EditGroupScreen;
